export default "__VITE_ASSET__935bdcf3__"